<h2 mat-dialog-title>{{ data.title | translate }}</h2>
<mat-dialog-content class="mat-typography">
  <form class="form-wrapper" [formGroup]="auswertungForm" autocomplete=off>

    <div class="eineLinie">
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.auswertungen.auswertungDialog.start' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.auswertungen.auswertungDialog.start' | translate"
          [matDatepicker]="picker"
          formControlName="start"
        />
        <mat-datepicker-toggle     [tabIndex]="-1" matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>

      </mat-form-field>
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.auswertungen.auswertungDialog.ende' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.auswertungen.auswertungDialog.ende' | translate"
          [matDatepicker]="endepicker"
          formControlName="ende"
        />
        <mat-datepicker-toggle    [tabIndex]="-1" matSuffix [for]="endepicker"></mat-datepicker-toggle>
        <mat-datepicker #endepicker></mat-datepicker>
      </mat-form-field>
    </div>


      <auswertungen-stufen class="stufenAnzeige"
                           [disablen]="disableProjektstufe"
                           [selectboxItems]="$projektSelectbox | async">
      </auswertungen-stufen>

    <mat-form-field class="cacheSelect" appearance="outline" color="accent">
      <mat-label>{{ 'pages.timeDialog.cache' | translate }}</mat-label>
      <mat-select (ngModelChange)="selectProjects($event)" formControlName="cache">
        <mat-option *ngFor="let cacheNode of ($cache | async)" [value]="cacheNode.id">
          {{cacheNode.obersteProjektstufe.join(' - ')}}
        </mat-option>
      </mat-select>
    </mat-form-field>

      <div class="dreiEineLinie">
        <div>
        <mat-checkbox formControlName="showZeit"
        class="checkboxAbstand"
                      (change)="checkZeitauswahl($event.checked)"
        >
        {{ 'pages.auswertungen.auswertungDialog.zeitAnzeigen' | translate }}</mat-checkbox>
        <mat-radio-group formControlName="zeitAuswahl">
          <mat-radio-button class="radioButton" value="1">{{ 'pages.auswertungen.auswertungDialog.zeitIntern' | translate }}</mat-radio-button>
          <mat-radio-button class="radioButton" value="2">{{ 'pages.auswertungen.auswertungDialog.zeitExtern' | translate }}</mat-radio-button>
        </mat-radio-group>
        </div>
        <div>

        <mat-checkbox formControlName="zwischensummen"
                      class="checkboxAbstand"
        >
          {{ 'pages.auswertungen.auswertungDialog.zwischensummen' | translate }}</mat-checkbox>
        <mat-checkbox formControlName="details"
                      class="checkboxAbstand"
        >
          {{ 'pages.auswertungen.auswertungDialog.details' | translate }}</mat-checkbox>
        </div>
        <div>
          <mat-checkbox formControlName="showSpesen"
                        class="checkboxAbstand"
                        (change)="checkSpesenauswahl($event.checked)"
          >     {{ 'pages.auswertungen.auswertungDialog.spesenAnzeigen' | translate }}</mat-checkbox>
          <mat-radio-group formControlName="spesenAuswahl">
          <mat-radio-button class="radioButton" value="1">{{ 'pages.auswertungen.auswertungDialog.spesenIntern' | translate }}</mat-radio-button>
          <mat-radio-button class="radioButton" value="2">{{ 'pages.auswertungen.auswertungDialog.spesenExtern' | translate }}</mat-radio-button>
        </mat-radio-group>
        </div>
        <div *ngIf="isSmallDevice">
        <mat-checkbox formControlName="benutzer"
                      class="checkboxAbstand"
        >        {{ 'pages.auswertungen.auswertungDialog.benutzer' | translate }}</mat-checkbox>
        <mat-checkbox formControlName="alleBenutzer"
                      class="checkboxAbstand"
                      [disabled]="!(showAlleBenutzer | async)"
        >
          {{ 'pages.auswertungen.auswertungDialog.alleBenutzer' | translate }}</mat-checkbox>
        </div>
        <mat-checkbox *ngIf="!isSmallDevice" formControlName="benutzer"
                      class="checkboxAbstand"
        >        {{ 'pages.auswertungen.auswertungDialog.benutzer' | translate }}</mat-checkbox>
        <mat-checkbox *ngIf="!isSmallDevice" formControlName="offen"
                      class="checkboxAbstand"
        >
          {{ 'pages.auswertungen.auswertungDialog.offen' | translate }}</mat-checkbox>

        <mat-checkbox formControlName="ferien"
                      class="checkboxAbstand"
                      (change)="setProjektstufeDisabled($event.checked)"
        >
          {{ 'pages.timeDialog.ferien' | translate }}
        </mat-checkbox>


    </div>
<div *ngIf="!isSmallDevice" class="eineLinie">

    <mat-checkbox formControlName="alleBenutzer"
                  class="checkboxAbstand"
                  [disabled]="!(showAlleBenutzer | async)"
    >
      {{ 'pages.auswertungen.auswertungDialog.alleBenutzer' | translate }}</mat-checkbox>

  <mat-checkbox formControlName="separat"
                class="checkboxAbstand"
  >
    {{ 'pages.auswertungen.auswertungDialog.separat' | translate }}</mat-checkbox>


</div>
    <div *ngIf="isSmallDevice" class="eineLinie">
  <!--
      <mat-checkbox formControlName="separat"
                    class="checkboxAbstand"
      >
        {{ 'pages.auswertungen.auswertungDialog.separat' | translate }}</mat-checkbox>
        -->
      <div></div>
      <mat-checkbox formControlName="offen"
                    class="checkboxAbstand"
      >
        {{ 'pages.auswertungen.auswertungDialog.offen' | translate }}</mat-checkbox>

    </div>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    id="abbruch"
    color="none"
    (click)="handleCancelClick()"
    [tabIndex]="-1"
  >
    {{ data.cancelButtonLabel | translate }}
  </button>
  <button
    mat-raised-button
    color="accent"
    (click)="handleSubmitClick()"
    [disabled]="auswertungForm.invalid"
  >
    {{ data.submitButtonLabel | translate }}
  </button>
</mat-dialog-actions>
